import { parseHtml } from '@utils/html';

interface IHtmlBlockProps {
    htmlString: string;
    className?: string;
}

export const HtmlBlock = ({ htmlString, className = '' }: IHtmlBlockProps) => {
    if (!htmlString) return;

    const parsedHtml = parseHtml(htmlString);
    return <div className={`${className}`}>{parsedHtml}</div>;
};
